import { z } from 'zod/v4';
import { UpdateCreditorSchema } from '../creditor/index.js';
import { CaseVoucherSchema, PatchCaseVoucherSchema, } from '../economy/case-vouchers/index.js';
import { PaymentPlanStatus } from '../economy/payment-plans/index.js';
import { AddressSchema, PhoneSchema } from '../index.js';
import { IntentSchema } from '../intents/index.js';
import { InteractionEventSchema } from '../interactions/events/index.js';
import { Direction, IncomingState, InteractionType, OutgoingState, } from '../interactions/index.js';
import { InteractionSchema } from '../interactions/schemas.js';
import { PerformedBySchema } from '../performed-by/index.js';
import { ConfiguredTriggerSchema } from '../procedures/index.js';
import { PriceListSchema } from '../tenants/index.js';
import { UpdateSchema } from '../updates/index.js';
export var BlameLogType;
(function (BlameLogType) {
    BlameLogType["CaseVoucherCreate"] = "VOUCHER-CREATE";
    BlameLogType["CaseVoucherDelete"] = "VOUCHER-DELETE";
    BlameLogType["CaseVoucherRestore"] = "VOUCHER-RESTORE";
    BlameLogType["UnknownCaseVoucherMapped"] = "UNKNOWN-CASE-VOUCHER-MAPPED";
    BlameLogType["CaseVoucherPatch"] = "CASE-VOUCHER-PATCH";
    BlameLogType["VisitedBy"] = "VISITED-BY";
    BlameLogType["CaseVisit"] = "CASE-VISIT";
    // Case lifecycle
    BlameLogType["CaseCreate"] = "CASE-CREATE";
    BlameLogType["CaseDelete"] = "CASE-DELETE";
    BlameLogType["CaseMerge"] = "CASE-MERGE";
    BlameLogType["CaseStatusChange"] = "CASE-STATUS-CHANGE";
    BlameLogType["CaseJournalNumberChange"] = "CASE-JOURNAL-NUMBER-CHANGE";
    BlameLogType["CaseCostCeilingAmountChange"] = "CASE-COST-CEILING-AMOUNT-CHANGE";
    BlameLogType["CaseCostCeilingEnabledChange"] = "CASE-COST-CEILING-ENABLED-CHANGE";
    BlameLogType["WorkflowChangeOnCase"] = "WORKFLOW-CHANGE-ON-CASE";
    BlameLogType["UserOnCustomerVisit"] = "USER-ON-CUSTOMER-VISIT";
    BlameLogType["DebtorUpdateName"] = "DEBTOR-UPDATE-NAME";
    BlameLogType["DebtorUpdatePhone"] = "DEBTOR-UPDATE-PHONE";
    BlameLogType["DebtorUpdateAddress"] = "DEBTOR-UPDATE-ADDRESS";
    BlameLogType["DebtorUpdateEmail"] = "DEBTOR-UPDATE-EMAIL";
    BlameLogType["DebtorUpdateCourt"] = "DEBTOR-UPDATE-COURT";
    BlameLogType["DebtorUpdateBirthdate"] = "DEBTOR-UPDATE-BIRTHDATE";
    BlameLogType["DebtorUpdateCVR"] = "DEBTOR-UPDATE-CVR";
    BlameLogType["DebtorUpdateCPR"] = "DEBTOR-UPDATE-CPR";
    BlameLogType["CreditorVisit"] = "CREDITOR-VISIT";
    BlameLogType["CreditorSettingsUpdate"] = "CREDITOR-SETTINGS-UPDATE";
    BlameLogType["CaseVoucherIrrecoverable"] = "VOUCHER-IRRECOVERABLE";
    BlameLogType["CaseVoucherExpired"] = "VOUCHER-EXPIRED";
    BlameLogType["InteractionCreate"] = "INTERACTION-CREATE";
    BlameLogType["InteractionDelete"] = "INTERACTION-DELETE";
    BlameLogType["InteractionHideFromClient"] = "INTERACTION-HIDE-FROM-CLIENT";
    BlameLogType["InteractionMappedToCase"] = "INTERACTION-MAPPED-TO-CASE";
    BlameLogType["InteractionUnmappedFromCase"] = "INTERACTION-UNMAPPED-FROM-CASE";
    BlameLogType["InteractionRollback"] = "INTERACTION-ROLLBACK";
    BlameLogType["DebtorWebLoginEId"] = "DEBTOR-WEB-LOGIN-E-ID";
    BlameLogType["WorkflowRollback"] = "WORKFLOW-ROLLBACK";
    BlameLogType["AutoDebtRegister"] = "AUTO-DEBT-REGISTER";
    BlameLogType["AutoRegisterInOpenRegistry"] = "AUTO-REGISTER-IN-OPEN-REGISTRY";
    BlameLogType["AutoIgnoreUnresolvedOppositions"] = "AUTO-IGNORE-UNRESOLVED-OPPOSITIONS";
    BlameLogType["AutoDeleteDebtRegistrationOnCaseEnd"] = "AUTO-DELETE-DEBT-REGISTRATION-ON-CASE-END";
    BlameLogType["AKSConfiguration"] = "AKS-CONFIGURATION";
    BlameLogType["AKSClientID"] = "AKS-CLIENT-ID";
    BlameLogType["RKIOveride"] = "RKI-OVERRIDE";
    BlameLogType["AKSActivated"] = "AKS-ACTIVATED";
    BlameLogType["PriceList"] = "PRICE-LIST";
    BlameLogType["UserPasswordUpdate"] = "USER-PASSWORD-UPDATE";
    BlameLogType["TriggerShortcut"] = "TRIGGER-SHORTCUT";
    BlameLogType["WorkflowChange"] = "WORKFLOW-CHANGE";
    BlameLogType["DeleteUpdate"] = "DELETE-UPDATE";
    BlameLogType["ConnectorBillingUpdate"] = "CONNECTOR-BILLING-UPDATE";
    BlameLogType["BulkAction"] = "BULK-ACTION";
    // Payment lifecycle
    BlameLogType["PaymentPlanCreate"] = "PAYMENT-PLAN-CREATE";
    BlameLogType["PaymentPlanPatched"] = "PAYMENT-PLAN-PATCH";
    BlameLogType["PaymentPlanDelete"] = "PAYMENT-PLAN-DELETE";
    BlameLogType["CaseVoucherMoved"] = "PAYMENT-MAPPED-TO-CASE";
    // Tribunal
    BlameLogType["TribunalCaseCreate"] = "TRIBUNAL-CASE-CREATE";
    BlameLogType["TribunalJobCreate"] = "TRIBUNAL-JOB-CREATE";
    BlameLogType["TribunalJobPatch"] = "TRIBUNAL-JOB-PATCH";
    BlameLogType["TribunalJobDelete"] = "TRIBUNAL-JOB-DELETE";
    // Documents
    BlameLogType["DocumentUpload"] = "DOCUMENT-UPLOAD";
    BlameLogType["DocumentDelete"] = "DOCUMENT-DELETE";
    BlameLogType["DocumentSigned"] = "DOCUMENT-SIGNED";
    // Fixed distributions
    BlameLogType["FixedDistributionCreate"] = "FIXED-DISTRIBUTION-CREATE";
    BlameLogType["FixedDistributionUpdate"] = "FIXED-DISTRIBUTION-UPDATE";
    BlameLogType["FixedDistributionDelete"] = "FIXED-DISTRIBUTION-DELETE";
    // Imports
    BlameLogType["ImportCreated"] = "IMPORT-CREATED";
    BlameLogType["ImportRun"] = "IMPORT-RUN";
})(BlameLogType || (BlameLogType = {}));
export var BlameLogRefType;
(function (BlameLogRefType) {
    BlameLogRefType["Case"] = "CASE";
    BlameLogRefType["User"] = "USER";
    BlameLogRefType["Creditor"] = "CREDITOR";
    BlameLogRefType["UserOnCustomer"] = "USER-ON-CUSTOMER";
    BlameLogRefType["TenantSettings"] = "TENANT-SETTINGS";
})(BlameLogRefType || (BlameLogRefType = {}));
export var CaseMergeDirection;
(function (CaseMergeDirection) {
    CaseMergeDirection["MergedTo"] = "MERGED_TO";
    CaseMergeDirection["MergedFrom"] = "MERGED_FROM";
})(CaseMergeDirection || (CaseMergeDirection = {}));
const EconomyBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.CaseVoucherCreate),
        details: z.object({
            caseVoucherId: z.string(),
            voucherTypeId: z.string(),
            amount: z.number(),
            referenceId: z.string().nullable(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherDelete),
        details: CaseVoucherSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherRestore),
        details: CaseVoucherSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.UnknownCaseVoucherMapped),
        details: z.string(),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherPatch),
        details: PatchCaseVoucherSchema.extend({
            caseVoucherId: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherExpired),
        details: CaseVoucherSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherIrrecoverable),
        details: CaseVoucherSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.CaseVoucherMoved),
        details: z.object({
            fromCaseId: z.string().nullable(),
            toCaseId: z.string().nullable(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.FixedDistributionCreate),
        details: z.object({
            fromCaseVoucherId: z.string(),
            toCaseVoucherId: z.string(),
            amount: z.number(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.FixedDistributionUpdate),
        details: z.object({
            id: z.string(),
            fromCaseVoucherId: z.string(),
            toCaseVoucherId: z.string(),
            previousAmount: z.number(),
            amount: z.number(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.FixedDistributionDelete),
        details: z.object({
            id: z.string(),
            fromCaseVoucherId: z.string(),
            toCaseVoucherId: z.string(),
            amount: z.number(),
        }),
    }),
]);
const InteractionBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.InteractionCreate),
        details: z.object({
            interactionId: z.string(),
            interactionType: z.string(),
            direction: z.string(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.InteractionDelete),
        details: z.object({
            id: z.uuid(),
            type: z.enum(InteractionType),
            seqId: z.number().nullable(),
            state: z.union([z.enum(OutgoingState), z.enum(IncomingState)]),
            events: z.array(InteractionEventSchema),
            intent: IntentSchema,
            createdAt: z.string(),
            direction: z.enum(Direction),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.InteractionHideFromClient),
        details: InteractionSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.InteractionRollback),
        details: InteractionSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.InteractionMappedToCase),
        details: z.object({
            interactionId: z.string(),
            interactionType: z.string(),
            fromCaseId: z.string().nullable().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.InteractionUnmappedFromCase),
        details: z.object({
            interactionId: z.string(),
            interactionType: z.string(),
        }),
    }),
]);
const VisitBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.CaseVisit),
        details: z.string(),
    }),
    z.object({
        type: z.literal(BlameLogType.UserOnCustomerVisit),
        details: z.string(),
    }),
    z.object({
        type: z.literal(BlameLogType.CreditorVisit),
        details: z.string(),
    }),
    z.object({
        type: z.literal(BlameLogType.VisitedBy),
        details: z.string(),
    }),
]);
const DebtorUpdateBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateName),
        details: z.string(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdatePhone),
        details: PhoneSchema.nullable(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateAddress),
        details: AddressSchema.nullable(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateEmail),
        details: z.string().nullish(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateCourt),
        details: z.string().nullable(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateBirthdate),
        details: z.string().nullable(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateCVR),
        details: z.string().nullable(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorUpdateCPR),
        details: z.string().nullish(),
    }),
    z.object({
        type: z.literal(BlameLogType.DebtorWebLoginEId),
        // TODO: Don't like this!!!
        details: z.object({
            authToken: z.string(),
            iss: z.string(),
            aud: z.string(),
            identityscheme: z.string(),
        }),
    }),
]);
const WorkflowBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.WorkflowChangeOnCase),
        details: z.object({
            fromWorkflowId: z.string().nullable(),
            toWorkflowId: z.string().nullable(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.WorkflowRollback),
        details: z.object({
            label: z.string().optional(),
            workflowTitle: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.WorkflowChange),
        details: z.object({
            workflowId: z.string(),
            prevWorkflowId: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.DeleteUpdate),
        details: UpdateSchema,
    }),
    z.object({
        type: z.literal(BlameLogType.BulkAction),
        details: z.object({ actionType: z.string() }),
    }),
]);
const CaseLifecycleBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.CaseCreate),
        details: z.object({
            creditorId: z.string(),
            customerId: z.string(),
            workflowId: z.string().nullish(),
            caseSeqId: z.number().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseDelete),
        details: z.object({
            previousStatus: z.string().optional(),
            reason: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseMerge),
        details: z.object({
            fromCaseId: z.string(),
            fromCaseSeqId: z.number(),
            toCaseId: z.string(),
            toCaseSeqId: z.number(),
            direction: z.enum(CaseMergeDirection),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseStatusChange),
        details: z.object({
            fromStatus: z.string(),
            toStatus: z.string(),
            endReasonId: z.string().nullish(),
            endReasonHandle: z.string().optional(),
            reason: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseJournalNumberChange),
        details: z.object({
            from: z
                .object({ journalNumber: z.string(), type: z.string() })
                .nullable(),
            to: z.object({ journalNumber: z.string(), type: z.string() }).nullable(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseCostCeilingAmountChange),
        details: z.object({
            from: z.number().nullable(),
            to: z.number().nullable(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.CaseCostCeilingEnabledChange),
        details: z.object({
            from: z.boolean().nullable(),
            to: z.boolean(),
        }),
    }),
]);
const CreditorBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.CreditorSettingsUpdate),
        details: UpdateCreditorSchema,
    }),
]);
const SettingsBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.AutoDebtRegister),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.AutoRegisterInOpenRegistry),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.AutoIgnoreUnresolvedOppositions),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.RKIOveride),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.AKSConfiguration),
        details: z.object({
            usernameChanged: z.boolean(),
            passwordChanged: z.boolean(),
            keyChanged: z.boolean(),
            codeChanged: z.boolean(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.AKSClientID),
        details: z.object({ clientId: z.string().nullable() }),
    }),
    z.object({
        type: z.literal(BlameLogType.AKSActivated),
        details: z.object({ toggled: z.boolean() }),
    }),
    z.object({
        type: z.literal(BlameLogType.PriceList),
        details: z.object({ priceList: PriceListSchema }),
    }),
    z.object({
        type: z.literal(BlameLogType.UserPasswordUpdate),
        details: z.object({ userId: z.string() }),
    }),
    z.object({
        type: z.literal(BlameLogType.TriggerShortcut),
        details: z.object({
            systemProcedure: z.string(),
            procedureId: z.array(z.string()).optional(),
            // The stored entry after the change, so settings-only edits (timespan,
            // foundation filter) are distinguishable in the audit trail.
            configurations: z.array(ConfiguredTriggerSchema).optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.ConnectorBillingUpdate),
        details: z.object({
            dunning: z.boolean(),
            connectorId: z.uuid(),
        }),
    }),
]);
const PaymentBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.PaymentPlanCreate),
        details: z.object({
            paymentPlanId: z.string().nullable(),
            entriesCount: z.number(),
            activationTrigger: z.boolean().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.PaymentPlanDelete),
        details: z.object({
            paymentPlanId: z.string(),
            previousStatus: z.string().optional(),
            reason: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.PaymentPlanPatched),
        details: z.object({
            paymentPlanId: z.string(),
            changes: z.unknown(),
            statusChange: z
                .object({
                from: z.enum(PaymentPlanStatus),
                to: z.enum(PaymentPlanStatus),
            })
                .optional(),
        }),
    }),
]);
const TribunalBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.TribunalCaseCreate),
        details: z.object({
            tribunalCaseId: z.string(),
            caseId: z.string(),
            type: z.string(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.TribunalJobCreate),
        details: z.object({
            tribunalJobId: z.string(),
            jobType: z.string(),
            tribunalCaseId: z.string().nullish(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.TribunalJobPatch),
        details: z.object({
            tribunalJobId: z.string(),
            jobType: z.string(),
            dateUpdated: z.string().nullish(),
            fileUploaded: z.boolean().optional(),
            costsRegistered: z.number().nullish(),
            meetingStateChanged: z.string().nullish(),
            noteUpdated: z.boolean().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.TribunalJobDelete),
        details: z.object({
            tribunalJobId: z.string(),
            jobType: z.string(),
            tribunalCaseId: z.string().nullish(),
        }),
    }),
]);
const DocumentBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.DocumentUpload),
        details: z.object({
            documentId: z.string(),
            documentType: z.string(),
            fileId: z.string().nullish(),
            fileName: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.DocumentDelete),
        details: z.object({
            documentId: z.string(),
            documentType: z.string().optional(),
            fileName: z.string().optional(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.DocumentSigned),
        details: z.object({
            documentId: z.string(),
            signedBy: z.string().optional(),
            signedAt: z.string().optional(),
        }),
    }),
]);
const ImportBlameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(BlameLogType.ImportCreated),
        details: z.object({
            importId: z.string(),
            creditorId: z.string(),
            caseGroupId: z.string().nullish(),
            source: z.string(),
        }),
    }),
    z.object({
        type: z.literal(BlameLogType.ImportRun),
        details: z.object({
            importId: z.string(),
            creditorId: z.string(),
            successCount: z.number(),
            updatedCount: z.number(),
            failedCount: z.number(),
        }),
    }),
]);
export const RawBlameLogSchema = z.union([
    EconomyBlameLogSchema,
    InteractionBlameLogSchema,
    VisitBlameLogSchema,
    DebtorUpdateBlameLogSchema,
    WorkflowBlameLogSchema,
    CaseLifecycleBlameLogSchema,
    CreditorBlameLogSchema,
    SettingsBlameLogSchema,
    PaymentBlameLogSchema,
    TribunalBlameLogSchema,
    DocumentBlameLogSchema,
    ImportBlameLogSchema,
]);
const BlameLogMetadataSchema = z.object({
    id: z.uuid(),
    refType: z.enum(BlameLogRefType),
    refId: z.string(),
    performedBy: PerformedBySchema.nullable(),
    loggedAt: z.iso.datetime(),
});
// Annotated because the inferred type is too large for TypeScript to emit
export const BlameLogSchema = z.intersection(RawBlameLogSchema, BlameLogMetadataSchema);
export const NewBlameLogSchema = z.intersection(RawBlameLogSchema, z.object({
    refType: z.enum(BlameLogRefType),
    refId: z.string(),
}));
export const BlameLogsFilterSchema = z.object({
    types: z.array(z.enum(BlameLogType)).optional(),
});
export const economyTypes = [
    BlameLogType.CaseVoucherCreate,
    BlameLogType.CaseVoucherDelete,
    BlameLogType.UnknownCaseVoucherMapped,
    BlameLogType.CaseVoucherPatch,
    BlameLogType.CaseVoucherExpired,
    BlameLogType.CaseVoucherIrrecoverable,
    BlameLogType.CaseVoucherMoved,
    BlameLogType.FixedDistributionCreate,
    BlameLogType.FixedDistributionUpdate,
    BlameLogType.FixedDistributionDelete,
];
export const interactionTypes = [
    BlameLogType.InteractionCreate,
    BlameLogType.InteractionDelete,
    BlameLogType.InteractionHideFromClient,
    BlameLogType.InteractionMappedToCase,
    BlameLogType.InteractionUnmappedFromCase,
    BlameLogType.InteractionRollback,
];
export const visitTypes = [
    BlameLogType.CaseVisit,
    BlameLogType.UserOnCustomerVisit,
    BlameLogType.CreditorVisit,
];
export const debtorUpdateTypes = [
    BlameLogType.DebtorUpdateName,
    BlameLogType.DebtorUpdatePhone,
    BlameLogType.DebtorUpdateAddress,
    BlameLogType.DebtorUpdateEmail,
    BlameLogType.DebtorUpdateCourt,
    BlameLogType.DebtorUpdateBirthdate,
    BlameLogType.DebtorUpdateCVR,
    BlameLogType.DebtorUpdateCPR,
];
export const workflowTypes = [
    BlameLogType.WorkflowRollback,
    BlameLogType.DeleteUpdate,
    BlameLogType.WorkflowChange,
    BlameLogType.BulkAction,
    BlameLogType.WorkflowChangeOnCase,
];
export const caseLifecycleTypes = [
    BlameLogType.CaseCreate,
    BlameLogType.CaseDelete,
    BlameLogType.CaseMerge,
    BlameLogType.CaseStatusChange,
    BlameLogType.CaseJournalNumberChange,
    BlameLogType.CaseCostCeilingAmountChange,
    BlameLogType.CaseCostCeilingEnabledChange,
];
export const paymentPlanTypes = [
    BlameLogType.PaymentPlanCreate,
    BlameLogType.PaymentPlanPatched,
    BlameLogType.PaymentPlanDelete,
];
export const tribunalTypes = [
    BlameLogType.TribunalCaseCreate,
    BlameLogType.TribunalJobCreate,
    BlameLogType.TribunalJobPatch,
    BlameLogType.TribunalJobDelete,
];
export const documentTypes = [
    BlameLogType.DocumentUpload,
    BlameLogType.DocumentDelete,
    BlameLogType.DocumentSigned,
];
export const importTypes = [BlameLogType.ImportCreated, BlameLogType.ImportRun];
export const settingTypes = [
    BlameLogType.AutoDebtRegister,
    BlameLogType.AutoRegisterInOpenRegistry,
    BlameLogType.AutoIgnoreUnresolvedOppositions,
    BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd,
    BlameLogType.AKSConfiguration,
    BlameLogType.AKSClientID,
    BlameLogType.RKIOveride,
    BlameLogType.AKSActivated,
    BlameLogType.PriceList,
    BlameLogType.UserPasswordUpdate,
    BlameLogType.TriggerShortcut,
    BlameLogType.ConnectorBillingUpdate,
    BlameLogType.CreditorSettingsUpdate,
];
//# sourceMappingURL=index.js.map